import { connect } from "react-redux";
import { useMemo } from "react";
import { INTEGRATION_TYPE, INTEGRATION_VARIABLE } from "../store/config";
import { Actions as SMART_PENSION_ACTIONS } from "../store/smartPensionActions";
import Spinner from "@/common/Spinner";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/20/solid";
import SchemeErrorsRow from "./SchemeErrorsRow";

const SchemeErrors = ({ title, status, errors }) => {
	const Icon = useMemo(() => {
		switch (status) {
			case "success":
				return <CheckCircleIcon style={{ color: "green", width: "2rem", display: "block" }} />;
			case "error":
				return <XCircleIcon style={{ color: "red", height: "2rem", display: "block" }} />;
			case "pending":
				return (
					<Spinner
						style={{ color: "green", width: "2rem", display: "block" }}
						className="animate-spin -ml-1 mr-3"
					/>
				);
			default:
				return null;
		}
	}, [status]);

	if (!title) return null;

	return (
		<div className="col-xs-12 form-section">
			<div
				className="col-xs-12 section-header"
				style={{ paddingBottom: errors?.length ? 0 : undefined }}
			>
				<div style={{ display: "flex", flexDirection: "row" }}>
					{Icon}
					<h1>
						{status} - {title}
					</h1>
				</div>
			</div>
			{errors?.length ? (
				<div className="col-xs-12">
					<div className="form-inner-section pr-0 pl-0">
						<div
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(10, minmax(0, 1fr))",
								padding: "1rem",
								borderBottom: "solid rgb(244,244,244) 4px",
							}}
						>
							<div style={{ gridColumn: "span 2 / span 10", textAlign: "center", opacity: "0.75" }}>
								<h5>Reference</h5>
							</div>
							<div style={{ gridColumn: "span 4 / span 10", textAlign: "center", opacity: "0.75" }}>
								<h5>Message</h5>
							</div>
							<div style={{ gridColumn: "span 2 / span 10", textAlign: "center", opacity: "0.75" }}>
								<h5>Employee</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 10", textAlign: "center", opacity: "0.75" }}>
								<h5>Expected</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 10", textAlign: "center", opacity: "0.75" }}>
								<h5>Provided</h5>
							</div>
						</div>
						{errors?.map((error, index) => {
							const isLast = index + 1 == errors.length;
							return <SchemeErrorsRow {...{ error, isLast }}></SchemeErrorsRow>;
						})}
					</div>
				</div>
			) : null}
		</div>
	);
};

const mapStateToProps = (state, { scheme }) => {
	const schemes = state.pensions?.scheme?.list?.map(({ connectionId, name}) => ({ value: connectionId, label: name }));

	const { errors, status } = scheme || {};
	const title = schemes?.find((s) => s.value === scheme.schemeId)?.label;

	return {
		title,
		status,
		errors: errors?.map((item) => ({ ...item, agreement: item.agreement?.toLowerCase?.() })),
		disabled: state?.permissions?.my?.permissions?.payroll == "Read",
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	closeModal: () => dispatch(SMART_PENSION_ACTIONS.toggleErrorsModal()),
	resend: (periodId) => {
		dispatch(SMART_PENSION_ACTIONS.toggleErrorsModal());
		dispatch(SMART_PENSION_ACTIONS.sendPayPeriodToSmartPension(periodId));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(SchemeErrors);
